import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageToggle from '../components/LanguageToggle'
import PrivacyPopup from '../components/PrivacyPopup'
import MenuPopup from '../components/MenuPopup';

function PrivacyPolicy({ onGoBack }) {
  const language = localStorage.getItem("appLanguage") || "en";
  const { t } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <link rel="shortcut icon" href="assets/images/favicon.ico" type="image/x-icon" />
      <link rel="stylesheet" href="https://use.typekit.net/hiu4ulc.css" />
      <link rel="stylesheet" href="assets/css/styles.css?ver=2.6" />
      <title>Privacy Policy | Britannia</title>
      <div className="page-wrapper">
        <div className="main-wrapper yellow-bg">
          {/*=============== DESKTOP SCREEN START ===============*/}
          <div className="d-frame-outer desktop-only">
            <img src="assets/images/desktop-star.webp" className="d-frame-star-bg" />
            <span className="d-frame-corner tl" />
            <span className="d-frame-corner tr" />
            <span className="d-frame-corner bl" />
            <span className="d-frame-corner br" />
            <div className="d-frame-border-outer">
              <div className="d-frame-border">
                <div className="d-frame-border-inner">
                  <div className="d-frame-canvas">
                    <div className="d-frame-content">
                      <div className="desktop-center">
                        <div className="desktop-content-box">
                          <h3>Thank you for your interest in participating in the</h3>
                          <img src="assets/images/desktop-logo-milk-bikis.webp" className="desktop-logo" alt="Milk Bikis Logo" />
                          <div className="desktop-qr-box">
                            <span className="qr-corner qr-corner-tl" />
                            <span className="qr-corner qr-corner-tr" />
                            <span className="qr-corner qr-corner-bl" />
                            <span className="qr-corner qr-corner-br" />
                            <div className="qr-left">
                              <p className="qr-text">Please scan the QR code on your phone to enter the experience :</p>
                            </div>
                            <div className="qr-right">
                              <img src="assets/images/desktop-qr.svg" alt="QR Code" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*=============== DESKTOP SCREEN END ===============*/}

          <div className="frame-outer mobile-only">
            <span className="frame-corner tl" />
            <span className="frame-corner tr" />
            <span className="frame-corner bl" />
            <span className="frame-corner br" />
            <div className="frame-border-outer">
              <div className="frame-border">
                <div className="frame-border-inner">
                  <div className="frame-canvas">
                    <div className="frame-content">


                      <div className="kural-screen rwd-screen">

                        <div className="kural-top">
                          <div className="kural-head-container">
                            <div className="logo-head">
                              <div className="camera-sc-logo-wrap">
                                <img src="assets/images/animate-britania-logo.webp" alt="Britannia" className="camera-sc-logo camera-sc-logo-1" />

                                <img src="assets/images/animate-milk-bikkis-logo.webp" alt="Milk Bikis" className="camera-sc-logo camera-sc-logo-2" />
                              </div>
                              <img src="assets/images/sign-up-head-text.webp" className="top-logo-text" alt="Top Logo" onClick={() => { window.location.href = "/home"; }} />

                              <div className="menu-bars" onClick={() => navigate("/menu")}>
                                <span></span>
                                <span></span>
                                <span></span>
                              </div>
                            </div>
                            {/* <LanguageToggle /> */}
                          </div>
                        </div>

                        <div className="kp-rwd-container">
                          <div className="kp-rwd-content-box">
                            <PrivacyPopup showCloseButton={false} />

                            <button onClick={() => navigate(-1)}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                padding: "8px 0px",
                              }}
                              className="kp-rwd-btn">
                              <span style={{ fontSize: language == "ta" ? "13px" : "17px" }}>{t("common.goBack")}</span>
                            </button>
                          </div>
                        </div>

                        <div className="kural-bottom">
                          <div className="kural-steps">
                            <span style={{ fontSize: language === "ta" ? "6px" : "8px" }}>{t("dashboard.scanStep")}</span>
                            <img src="assets/images/right-arrow-icon.webp" alt="arrow" className="arrow-img" />
                            <span style={{ fontSize: language === "ta" ? "6px" : "8px" }}>{t("dashboard.completeStep")}</span>
                            <img src="assets/images/right-arrow-icon.webp" alt="arrow" className="arrow-img" />
                            <span style={{ fontSize: language === "ta" ? "6px" : "8px" }}>{t("dashboard.sendVideoStep")}</span>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PrivacyPolicy
